import { render, staticRenderFns } from "./tempfilelist.vue?vue&type=template&id=63e74da5&"
import script from "./tempfilelist.vue?vue&type=script&lang=js&"
export * from "./tempfilelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports